/**
 * Site-wide version + copyright footer (§E, locked with Ben 2026-06-17).
 *
 *   Left:  © {year} AvSuite           — year dynamic
 *   Right: Version: Beta {x.y.z}      — sourced from package.json via Vite `define`
 *
 * Display rule derives the form from the version automatically: "Beta x.y.z" while the
 * major version is 0 (beta), "vx.y.z" once it hits 1.0.0+ — no manual edit at GA.
 *
 * Copyright entity is AvSuite (the product/company). Flight Standards is a CLIENT of
 * AvSuite — the copyright must never read "Flight Standards".
 *
 * Rendered once globally (App.tsx) so it sits at the bottom of every page's flow,
 * including the full-height OpsBoard. Muted, low-contrast, doesn't fight page layout.
 */
function versionLabel(version: string): string {
  const major = Number(version.split('.')[0]);
  return Number.isFinite(major) && major >= 1 ? `v${version}` : `Beta ${version}`;
}

export default function Footer() {
  const year = new Date().getFullYear();
  const label = versionLabel(__APP_VERSION__);

  return (
    <footer
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: '8px 18px',
        background: '#0f172a',
        borderTop: '1px solid #1e293b',
        color: '#64748b',
        fontSize: 11.5,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      }}
    >
      <span>© {year} AvSuite</span>
      <span style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <a
          href="https://avsuite.com.au"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#7dd3fc', textDecoration: 'none' }}
        >
          avsuite.com.au ↗
        </a>
        <span>Version: {label}</span>
      </span>
    </footer>
  );
}
